import markingEnum from "./markingEnum";
import util from "./util";

export const markingData = {
  fixQuestionGroupNum: (resp) => {
    const task = resp.body
    if (task) {
      task.assignType = markingEnum.AssignType.indexOf(task.assignType)
      task.judgeType = markingEnum.AssignType.indexOf(task.judgeType)
      task.type = markingEnum.GradingTimes.indexOf(task.type)
      task.pauseStatus = markingEnum.PauseStatus.indexOf(task.type)
      task.gradingNumInfo = {
        firstTeachersInfo: []
      }
      for (let index = 0; index < task.firstTeachers.length; index++) {
        const { schoolId, schoolName, teacherId, teacherName, todoGradingNum } = task.firstTeachers[index];
        task.gradingNumInfo.firstTeachersInfo.push({
          gradingNum: task.teacherMaxGradingNumMap[teacherId],
          schoolId, schoolName, teacherId, teacherName, todoGradingNum
        })
      }
    }
    return resp
  },
  fixWuHenSet: (resp, key = 'gradingTasks') => {
    if (resp.body) {
      resp.body.isGrading = markingEnum.GradingStatus.indexOf(resp.body.isGrading)
      resp.body.examStatus = markingEnum.GradingStatus.indexOf(resp.body.memberStatus)
      resp.body.assignType = markingEnum.AssignMode.indexOf(resp.body.assignMode)
      for (let index = 0; index < resp.body[key].length; index++) {
        const task = resp.body[key][index];
        task.assignType = markingEnum.AssignType.indexOf(task.assignType)
        task.judgeType = markingEnum.AssignType.indexOf(task.judgeType)
        task.type = markingEnum.GradingTimes.indexOf(task.type)
        task.pauseStatus = markingEnum.PauseStatus.indexOf(task.pauseStatus)
      }

      resp.body.schoolList = resp.body.schoolsOfRegion || resp.body.examGradingSchools
      if (resp.body.subjectiveStands) {
        resp.body.subjectiveStands.forEach(item => {
          item.isChecked = false
          item.images = item.standRanges.map(s => s.ossUrl)
        })
        const pointArr = resp.body.subjectiveStands.map((item) => item.score);
        resp.body.maxScore = Math.ceil(Math.max(...pointArr));
      }


      if (resp.body.gradingTasks) {
        resp.body.gradingTasks.forEach(item => {
          // 取最小值
          item.point = item.questions ? item.questions.reduce((min, current) => {
            return current.score < min ? current.score : min;
          }, item.questions[0].score) : 0
          item.nums = item.questions ? item.questions.map(s => util.standardQuestionNumber(s)).join(',') : '--'
          item.schoolIds = item.allocationSchools ? item.allocationSchools.filter(s => s.isSelected === 1).map(s => s.schoolId) : []
          item.assignNum = item.allocationSchools ? item.allocationSchools.reduce((sum, e) => sum + Number(e.assignNum || 0), 0) : 0
          item.schoolNum = item.schoolIds.length
          item.schoolsOfRegion = resp.body.schoolList
        })
      }
    }
    return resp
  },
  trySetParams (params) {
    try {
      params.assignType = markingEnum.AssignType[params.assignType]
      params.judgeType = markingEnum.AssignType[params.judgeType]
      params.type = markingEnum.GradingTimes[params.type]
    } catch (error) { }
  },
  fixMarkTaskList (resp) {
    if (resp.body) {
      const newResp = {
        body: resp.body,
        "code": 200,
        "message": "成功",
        "pageNo": 0,
        "pageSize": 0,
        "pageTotal": 0,
        "result": {
          "gradingVos": [],
          "isGrading": markingEnum.GradingStatus.indexOf(resp.body.isGrading),
          "ossUrl": "",
          "quesMsgVos": [],
          "resultTotal": 10,
          "schools": resp.body.schools,
          "subjectCode": resp.body.subjectCode,
          "versionType": 1
        },
        "status": "OK",
        "total": 0
      }
      for (let index = 0; index < resp.body.gradingTasks.length; index++) {
        const task = resp.body.gradingTasks[index];
        const item = {
          assignType: markingEnum.AssignType.indexOf(task.assignType),
          evaluateType: markingEnum.GradingTimes.indexOf(task.type),
          groupId: task.groupId,
          judgeType: markingEnum.AssignType.indexOf(task.judgeType),
          pauseStatus: markingEnum.PauseStatus.indexOf(task.pauseStatus),
          whetherInit: task.whetherInit,
          gradingVos: [],
          oneTeachers: [],
          assignNum: -1,
          assignTotal: task.assignTotal,
          defaultCount: -1,
          gradingType: -1,
          isAuto: -1,
          whetherCombine: -1,
          schoolNum: -1,
          scoreType: -1,
          scoreboardType: -1,
          showScale: -1,
          presetScore: [],
          schoolIds: [],
          threeTeachers: [],
          twoTeachers: []
        }
        if (task.allocationSchools) {
          item.assignNum = 0
          for (let index = 0; index < task.allocationSchools.length; index++) {
            const school = task.allocationSchools[index];
            item.assignNum += school.assignNum
            if (school.isSelected) {
              item.schoolIds.push(school.schoolId)
            }
          }
          item.schoolNum = item.schoolIds.length
        }
        if (task.firstTeachers) {
          for (let index = 0; index < task.firstTeachers.length; index++) {
            const teacher = task.firstTeachers[index];
            const temTeacher = {
              id: teacher.teacherId,
              nickName: teacher.teacherName,
              schoolName: teacher.schoolName,
              teacherGradingAssignVo: [],
              todoGradingNum: teacher.todoGradingNum
            }
            item.oneTeachers.push(temTeacher)
          }
        }

        if (task.secondTeachers) {
          for (let index = 0; index < task.secondTeachers.length; index++) {
            const teacher = task.secondTeachers[index];
            const temTeacher = {
              id: teacher.teacherId,
              nickName: teacher.teacherName,
              schoolName: teacher.schoolName,
              teacherGradingAssignVo: [],
              todoGradingNum: teacher.todoGradingNum
            }
            item.twoTeachers.push(temTeacher)
          }
        }
        // subjectiveStands
        for (let index = 0; index < task.questions.length; index++) {
          const ques = task.questions[index];
          const temQues = {
            "academicYear": -1,
            "assignNum": -1,
            "assignType": -1,
            "bigNum": ques.bigNum,
            "diffValue": ques.diffValue,
            "evaluateType": -1,
            "examId": task.examId,
            "groupId": task.groupId,
            "id": -1,
            "isSplit": ques.isSplit,
            "judgeType": -1,
            "num": ques.num,
            "pauseStatus": -1,
            "point": -1,
            "presetScore": [],
            "question": ques.question,
            "questionSplitVos": ques.questionSplits,
            "schoolId": task.schoolId,
            "scoreType": -1,
            "smallNum": ques.smallNum,
            "type": 1,
            "whetherCombine": -1,
            "whetherInit": -1
          }
          item.gradingVos.push(temQues)
        }
        newResp.result.gradingVos.push(item)
      }
      if (resp.body.subjectiveStands) {
        for (let index = 0; index < resp.body.subjectiveStands.length; index++) {
          const subQues = resp.body.subjectiveStands[index];
          const temQues = {
            "examStandVo": {
              "academicYear": "2023",
              "alias": "-404",
              "answer": "-404",
              "answerB": "-404",
              "answerCoordinate": "-404",
              "answerCoordinateInit": "-404",
              "bankCode": "-404",
              "bigNum": subQues.bigNum,
              "cQuestion": "-404",
              "choiceType": -404,
              "createTime": -404,
              "delFlag": -404,
              "examId": subQues.examId,
              "halfChoiceJson": "[]",
              "halfPoint": -404,
              "id": subQues.num,
              "isAb": -404,
              "num": subQues.num,
              "optionCoordinate": "-404",
              "optionCoordinateInit": "-404",
              "optionNum": -404,
              "optionNumInit": -404,
              "orderNum": -404,
              "pid": "-404",
              "point": subQues.score,
              "pointCoordinate": "-404",
              "pointCoordinateInit": "-404",
              "position": subQues.position,
              "positionTwo": subQues.positionTwo,
              "question": subQues.question,
              "questionType": -404,
              "rdnum": "-404",
              "rotateDegree": subQues.rotateDegree,
              "smallNum": subQues.smallNum,
              "sourceType": -404,
              "standUrl": subQues.standUrl,
              "type": -404,
              "updateTime": -404,
              "useStatus": -404
            },
            "isAllot": subQues.isAllot,
            "isAuto": -404,
            "id": subQues.num,
          }
          newResp.result.quesMsgVos.push(temQues)
        }
      }
      if (resp.body.examGradingSchools) {
        newResp.result.schools = []
        for (let index = 0; index < resp.body.examGradingSchools.length; index++) {
          const school = resp.body.examGradingSchools[index];
          const temSchool = {
            "disSucNum": school.disSucNum,
            "examCode": resp.body.examCode,
            "examId": resp.body.examId,
            "examName": '404',
            "grade": '404',
            "isSelected": school.isSelected,
            "readOverNum": school.hasGradingRecord,
            "schoolId": school.schoolId,
            "schoolName": school.schoolName,
            "scoreFlag": '404',
            "subjectName": '404'
          }
          newResp.result.schools.push(temSchool)
        }
      }
      return newResp
    }
    return resp
  }
}


// WEBPACK FOOTER //
// ./src/v2/utils/fixData.js